import React from 'react';
import cn from 'classnames';
import { ICard } from '../../../../types/Card';
import { DH } from '../../../../utils/DataHook';
import { t } from '../../../../utils/i18n';
import s from '../styles.scss';
import { Icon } from '../../elements';
import { stringifyExpirationDate } from '../../../../utils/expirationUtils';

interface ICardRowProps {
  isExpanded?: boolean;
  isExpired: boolean;
  card: ICard;
  rtl: boolean;
}

interface IBackButtonProps {
  onClick: () => void;
  rtl: boolean;
}

interface ICardContainerProps {
  dataHook: string;
  onClick?: () => void;
}

export const CardRowContainer: React.FC<React.PropsWithChildren<ICardContainerProps>> = (props) => (
  <section data-hook={props.dataHook} className={s.cardRowContainer} onClick={props.onClick ? props.onClick : null}>
    {props.children}
  </section>
);
CardRowContainer.displayName = 'CardRowContainer';

export const CardRow: React.FC<ICardRowProps> = (props) => {
  const { card, isExpanded, isExpired, rtl } = props;

  return (
    <>
      <section className={s.header}>
        <Icon
          cardNetwork={card.network}
          className={cn({
            [s.icon]: true,
            [s.iconRTL]: rtl,
          })}
        />
        <span
          data-hook={DH.CardRow.Number}
          className={cn({
            [s.expandedNetwork]: isExpanded,
            [s.rtm]: rtl,
          })}
        >
          {t(`network.${card.network}`)} ({card.lastFourDigits})
        </span>
        {!isExpanded && (
          <div
            className={cn({
              [s.arrow]: true,
              [s.arrowRTL]: rtl,
            })}
          />
        )}
      </section>
      <div
        data-hook={DH.CardRow.ExpireDate}
        className={cn({
          [s.expired]: isExpired,
          [s.rtm]: rtl,
        })}
      >
        {t('app.card.expiration-date-short')} {stringifyExpirationDate(card.expiration)}
        {isExpired && ` (${t('app.card.expired')})`}
      </div>
    </>
  );
};
CardRow.displayName = 'CardRow';

export const BackButton: React.FC<IBackButtonProps> = (props) => (
  <div
    data-hook={DH.CardRow.BackButton}
    className={cn({
      [s.arrowContainer]: true,
      [s.rtl]: props.rtl,
    })}
    onClick={props.onClick}
  >
    <div className={cn(s.arrowBack, s.arrow)} />
    <div>{t('app.card.back-button')}</div>
  </div>
);
BackButton.displayName = 'BackButton';
